import React from "react";
// import * as FaIcons from "react-icons/fa";
import { AiFillHome, AiOutlineApartment } from "react-icons/ai";
import { BsDot, BsPerson } from "react-icons/bs";

export const IconSelector = (props) => {
  const { iconname } = props;

  switch (iconname) {
    case "ai_fill_home":
      return <AiFillHome {...props} />;

    case "ai_outline_apartment":
      return <AiOutlineApartment {...props} />;

    case "bs_dot":
      return <BsDot {...props} />;

    case "bs_person":
      return <BsPerson {...props} />;

    default:
      return <AiFillHome {...props} />;
  }
};
